import { Component, OnInit, Input } from '@angular/core';

export interface FaqCardModel {
    title: string;
    faqs: {
        question: string;
        answer: string;
    }[];
}

@Component({
    selector: 'app-faq-card',
    templateUrl: './faq-card.component.html',
    styleUrls: ['./faq-card.component.scss'],
})
export class FaqCardComponent implements OnInit {
    @Input() faqs: FaqCardModel;

    get questions() {
        return this.faqs.faqs;
    }

    constructor() {}

    ngOnInit() {}
}
